const CONTAINER_TILE_MIN_WIDTH = 6;
const CONTAINER_TILE_MIN_HEIGHT = 3;

exports.CONTAINER_TILE_MIN_WIDTH = CONTAINER_TILE_MIN_WIDTH;
exports.CONTAINER_TILE_MIN_HEIGHT = CONTAINER_TILE_MIN_HEIGHT;
